export default __webpack_public_path__ + "static/media/mirror.188837d7.png";